export class AppError {
    constructor (public originalError?: any, public formObject?: any) {}
}
